import NotificationApi from '@/api/notification'
import { NotificationSettingModel } from './Notification/NotificationSetting'
import { NotificationModel } from './Notification/Notification'
import { PageSize } from '@/models/Notification/Constants'

export class NotificationRepository {
  static async registerNotifictaion(data) {
    const res = await NotificationApi.registerNotifictaion(data)
    return res
  }

  static async getAllNotificationsByIsRead(notificationType, isRead) {
    let pageNo = 0
    let items = []
    let res = null
    do {
      pageNo++
      res = await NotificationApi.getNotificationsByIsRead(
        notificationType,
        pageNo,
        PageSize,
        isRead,
      )
      items = items.concat(
        res.items.map(item => NotificationModel.assign(item)),
      )
    } while (res.count > pageNo * PageSize)

    return items
  }

  static async getNotificationsByPageNo(notificationType, pageNo) {
    const res = await NotificationApi.getAllNotifications(
      notificationType,
      pageNo,
      PageSize,
    )
    res.items.map(item => NotificationModel.assign(item))
    return res
  }

  static async getUnreadNotificationCount() {
    const res = await NotificationApi.getUnreadNotificationCount()
    return res.item
  }

  static async readNotification(notificationIds) {
    const res = await NotificationApi.readNotification(notificationIds)
    return res
  }

  static async getNotificationSettings() {
    const res = await NotificationApi.getNotificationSettings()
    return res.item.map(item => NotificationSettingModel.assign(item))
  }

  static async registerNotificationSetting(setting) {
    const res = await NotificationApi.registerNotificationSetting(setting)
    return res.item
  }

  static async changeNotificationSetting(setting) {
    const res = await NotificationApi.changeNotificationSetting(setting)
    return res.item
  }
}
